module.exports = __webpack_public_path__ + "img/cover.0c29a6ff.png";